export default "__VITE_ASSET__0eee09d5__"